import api from 'utils/apiClient';

export const loadChatAnnouncements = (params) => {
  return api.get('/chat_announcements', {
    params,
  });
};

export const createChatAnnouncement = (data) => {
  return api.post('/chat_announcements', data);
};

export const editChatAnnouncement = (id, data) => {
  return api.patch(`/chat_announcements/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  });
};

export const sendChatAnnouncement = (id) => {
  return api.post(`/chat_announcements/${id}/send`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteChatAnnouncement = (id) => {
  return api.delete(`/chat_announcements/${id}`);
};

export const getSystemUser = () => {
  return api.get('/system-user');
};
